module.exports = __webpack_public_path__ + "img/Online_Classes_2021.e3f61038.jpg";